import { createSelector } from 'reselect';

import { RootState } from '../../reducers';

export const getSelectedCalendar = (state: RootState) => state.application.reports.calendar;

export const getActiveCalendar = createSelector(
  [getSelectedCalendar],
  (selectedCalendar) => selectedCalendar.activePeriod,
);

export const getCalendarDates = createSelector([getSelectedCalendar], (selectedCalendar) => ({
  from: selectedCalendar.from,
  to: selectedCalendar.to,
}));
